module.exports = __webpack_public_path__ + "img/small.af8417fa.jpg";